const partnersText = [
  {
    heading: "We collaborate with",
  },
  {
    heading: "Bendradarbiaujame su",
  },
  {
    heading: "Współpracujemy z",
  },
];

export default partnersText;
